import React, { useEffect, useState } from 'react';
import { Button } from './ui';
import { Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://frezzer-lleno.impultienda.ar/checkout';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-14 px-3 sm:px-4 bg-teal-50 border-y-2 border-teal-200 relative" id="planes" data-id="element-157" data-mp="qjy3cypey7do">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-teal-500/15 via-teal-50 to-teal-50 pointer-events-none" data-id="element-158" data-mp="uljjqu15p3sm"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-159" data-mp="1f20vsjeyuhrr">
        <div className="text-center mb-5" data-id="element-160" data-mp="1f4n3cj1uwx9z">
          <div className="inline-flex items-center gap-2.5 bg-red-500/15 text-red-600 border border-red-500/40 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-161" data-mp="1a2e8ti9c5n5r">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-162" data-mp="22qjse1onl640" />
            <span data-id="element-163" data-mp="1xt1ud6c6cbas">PRECIO ACTUAL — CIERRA EN:</span>
            <span className="tabular-nums text-red-700 text-base sm:text-lg font-black tracking-wide" data-id="element-164" data-mp="1xta6gw0h3ckx">
              {String(timeLeft.h).padStart(2, '0')}:
              {String(timeLeft.m).padStart(2, '0')}:
              {String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-amber-600 font-medium text-sm flex items-center justify-center gap-2" data-id="element-165" data-mp="2ljxh3p1rwgb6">
            ⚠️ Después vuelve al precio de referencia de USD 49.99.
          </p>
          <div className="w-full max-w-md mx-auto mt-3 bg-cream-300 rounded-full h-1.5 overflow-hidden" data-id="element-166" data-mp="ev58op3ipy24">
            <div className="bg-brand-500 h-full w-[72%]" data-id="element-167" data-mp="jrvnza7i0pmh"></div>
          </div>
          <p className="text-[11px] text-ink-soft mt-1.5" data-id="element-168" data-mp="552iewns6y7h">
            Pago único · 100% digital · Acceso inmediato
          </p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-navy mb-7" data-id="element-169" data-mp="a1j7pu6pvim5">
          OBTENÉ TU KIT
        </h2>

        {/* Plan selector */}
        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí tu Kit" data-id="element-170" data-mp="5pm7lb0ses8">
          <button type="button" role="radio" aria-checked={true} className="relative w-full text-left rounded-2xl border-2 p-5 sm:p-7 transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-teal-50 border-brand-500 bg-white shadow-[0_20px_45px_-18px_rgba(6,182,212,0.55),0_0_0_6px_rgba(6,182,212,0.07)]" data-id="element-171" data-mp="3icni30yxvd4n">
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-172" data-mp="311qjzel9gbht">
              {/* Radio */}
              <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors border-brand-400 bg-brand-500" aria-hidden="true" data-id="element-173" data-mp="3fqeav7k5vx1f">
                <span className="w-2 h-2 rounded-full bg-white" data-id="element-174" data-mp="3oq9s9u4b8o9w"></span>
              </span>

              {/* Left content */}
              <div className="min-w-0 flex-1" data-id="element-175" data-mp="3jr6ose3zaq41">
                <h3 className="font-bold text-navy text-base sm:text-lg flex items-center gap-2 leading-tight" data-id="element-176" data-mp="2junfb1raank">
                  <span className="shrink-0" data-id="element-177" data-mp="3tpmeccncxrbf">
                    <span className="text-2xl leading-none" data-id="element-178" data-mp="3tqp76q48q3tz">🧩</span>
                  </span>
                  <span className="truncate" data-id="element-179" data-mp="24brbfk541cz8">KIT DE CONDUCTA INFANTIL</span>
                </h3>
                <p className="text-teal-600 text-xs font-semibold mt-1.5" data-id="element-180" data-mp="1zdphu5a25v9i">
                  3 Tomos + 5 Bonos
                </p>
                <p className="text-ink-muted text-xs mt-3 leading-relaxed" data-id="element-181" data-mp="qhk9xxbstz67">
                  <span className="text-ink-soft font-medium" data-id="element-182" data-mp="vcg350sruskw">
                    Ideal para:{' '}
                  </span>
                  Madres, padres y cuidadores que quieren dejar de improvisar
                  frente a rabietas, límites, rutinas y otras situaciones
                  difíciles del día a día
                </p>
                <p className="text-[11px] font-semibold mt-3 text-emerald-600" data-id="element-183" data-mp="cnt2cuhmopd4">
                  Pago único
                </p>
              </div>

              {/* Right price column */}
              <div className="shrink-0 text-right pl-1" data-id="element-184" data-mp="lg3b07cvkms9">
                <p className="text-ink-soft line-through text-xs leading-none mb-1.5" data-id="element-185" data-mp="lgwixbnklibz">
                  49.99
                </p>
                <p className="text-4xl sm:text-5xl font-black text-navy leading-none tracking-tight" data-id="element-186" data-mp="3l1s64iaudf16">
                  19.99
                </p>
                <p className="text-[11px] font-semibold tracking-wider text-ink-muted mt-1.5" data-id="element-187" data-mp="3hlxaf92sxkme">
                  USD
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Single main CTA */}
        <div className="max-w-2xl mx-auto mt-6" data-id="element-188" data-mp="38j60xethkyxe">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(6,182,212,0.4)]" onClick={() => {
          window.location.href = CHECKOUT_URL;
        }} data-id="element-189" data-mp="33mfkurhom3bz">
            → QUIERO MI KIT DE CONDUCTA INFANTIL AHORA
          </Button>
          <p className="text-center text-xs text-ink-soft mt-3" data-id="element-190" data-mp="2owqg6madrh6y">
            Garantía 7 días · Pago seguro · Acceso inmediato · 100% digital
          </p>
        </div>
      </div>
    </section>;
}